import DashboardSpecialCodesHeader from "./DashboardSpecialCodesHeader";

export default DashboardSpecialCodesHeader;
